export default function contractStatusFormatter(statusType, status) {
  // statusType = status / queue

  if (statusType === "queue") {
    switch (status) {
      case 0:
        return "Ready";
      case 1:
        return "Scheduled";
      case 2:
        return "Ordered";
      case 3:
        return "Contract Documentation";
      case 4:
        return "Contract Documentation Approved";
      case 5:
        return "Paid";
      case 6:
        return "Images Rejected";
      case 7:
        return "Units Warrantied";
      case 8:
        return "Images Rejected";
      default:
        return "";
    }
  } else {
    switch (status) {
      case "0":
        return "Incomplete";
      case "1":
        return "Submitted";
      case "2":
        return "Approved";
      case "3":
        return "Declined";
      case "5":
        return "Re-Execute";
      default:
        return "";
    }
  }
}
